<template>
	<div v-bind:class="contraer ? 'col-md-9 panel-main' : 'col-md-10 panel-main'">
		<div class="row general">
			<div class="col-md-12">
				<iframe :src="data" class="frame" id="frame"></iframe>
			</div>
		</div>
	</div>
</template>
<script lang="ts">

	export default 
	{
		name: "General",
		props: {
			contraer: Boolean,
		},
		data() {
			return {
				periodo: "", // Variable local que guarda el periodo en curso
			}
		},
		created() {

			this.periodo = this.$periodo
		},
		mounted: function() {

			const that = this

			// Capturamos el evento CAMBIO-PERIODO para actualizar la data
			window.event.$on("evento-cambio-periodo", function(periodo) {

				that.periodo = periodo
			})
		},
		computed: {

			// Funcion llamada desde el IFRAME para obtener el SRC
			data: function() {

				return this.getData()
			}
		},
		methods: {

			// Metodo que obtiene la URL para actualizar el IFRAME
			getData() {

				var tmp = this.periodo.split("-")

				var finicio = this.periodo.substr(0, 7) + "-01"
				var fecha = new Date(tmp[0], tmp[1], 0)
				var ffinal = this.periodo.substr(0, 7) + "-" + fecha.getDate()
				var src = ""

				// Vista Resumen
				src = this.$api + "/kibana/app/dashboards#/view/b998c600-3acb-11e9-a075-d56d28588383?embed=true&_g=(refreshInterval%3A(pause%3A!t%2Cvalue%3A0)%2Ctime%3A(from%3A%27" + finicio + "T00%3A00%3A00.000Z%27%2Cto%3A%27" + ffinal + "T23%3A59%3A59.999Z%27))"


				return src
			},
		}
	}

</script>
<style scoped>

	.general {
		padding-top: 10px;
		overflow: auto;
	}

	.frame {
		width: 100%;
		height: 800px;
	}

</style>
